export default __webpack_public_path__ + "static/speck-243331be367fbd61ea97af7ffa8e103e.png";